import { render } from "./Freshers.vue?vue&type=template&id=17ed5f02"
import script from "./Freshers.vue?vue&type=script&lang=js"
export * from "./Freshers.vue?vue&type=script&lang=js"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__